import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { HttpStateError, NormalisedResult, PaginationResult } from "@orm/models";
import * as actionTypes from "../constants";
import { Album, Track, MusicNormalisedEntities } from "../models";

export type AlbumsResult = NormalisedResult<number[], MusicNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

// Albums
export const requestAlbumsIndex = actionCreator<{}>(actionTypes.ALBUM_INDEX_REQUEST);
export const albumsIndexSuccess = actionCreator<[PaginationResult, AlbumsResult]>(
    actionTypes.ALBUM_INDEX_SUCCESS,
);
export const albumsIndexFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_INDEX_FAILURE);

export const requestAlbumsStore = actionCreator<Album>(actionTypes.ALBUM_STORE_REQUEST);
export const albumsStoreSuccess = actionCreator<Album>(actionTypes.ALBUM_STORE_SUCCESS);
export const albumsStoreFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_STORE_FAILURE);

export const requestAlbumsShow = actionCreator<number>(actionTypes.ALBUM_SHOW_REQUEST);
export const albumsShowSuccess = actionCreator<NormalisedResult<number, MusicNormalisedEntities>>(
    actionTypes.ALBUM_SHOW_SUCCESS,
);
export const albumsShowFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_SHOW_FAILURE);

export const requestAlbumsUpdate = actionCreator<Album>(actionTypes.ALBUM_UPDATE_REQUEST);
export const albumsUpdateSuccess = actionCreator<Album>(actionTypes.ALBUM_UPDATE_SUCCESS);
export const albumsUpdateFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_UPDATE_FAILURE);

export const requestAlbumsDestroy = actionCreator<number>(actionTypes.ALBUM_DESTROY_REQUEST);
export const albumsDestroySuccess = actionCreator<number>(actionTypes.ALBUM_DESTROY_SUCCESS);
export const albumsDestroyFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_DESTROY_FAILURE);

export const requestAlbumsSearch = actionCreator<string>(actionTypes.ALBUM_SEARCH_REQUEST);
export const albumsSearchSuccess = actionCreator<NormalisedResult<number[], MusicNormalisedEntities>>(
    actionTypes.ALBUM_SEARCH_SUCCESS,
);
export const albumsSearchFailure = actionCreator<HttpStateError>(actionTypes.ALBUM_SEARCH_FAILURE);

// Tracks
export const requestTracksIndex = actionCreator<{}>(actionTypes.TRACK_INDEX_REQUEST);
export const tracksIndexSuccess = actionCreator<NormalisedResult<number[], MusicNormalisedEntities>>(
    actionTypes.TRACK_INDEX_SUCCESS,
);
export const tracksIndexFailure = actionCreator<HttpStateError>(actionTypes.TRACK_INDEX_FAILURE);

export const requestTracksStore = actionCreator<Album>(actionTypes.TRACK_STORE_REQUEST);
export const tracksStoreSuccess = actionCreator<Album>(actionTypes.TRACK_STORE_SUCCESS);
export const tracksStoreFailure = actionCreator<HttpStateError>(actionTypes.TRACK_STORE_FAILURE);

export const requestTracksShow = actionCreator<number>(actionTypes.TRACK_SHOW_REQUEST);
export const tracksShowSuccess = actionCreator<NormalisedResult<number, MusicNormalisedEntities>>(
    actionTypes.TRACK_SHOW_SUCCESS,
);
export const tracksShowFailure = actionCreator<HttpStateError>(actionTypes.TRACK_SHOW_FAILURE);
export const tracksShowRedirect = actionCreator<[number, number]>(actionTypes.TRACK_SHOW_REDIRECT);

export const requestTracksUpdate = actionCreator<Album>(actionTypes.TRACK_UPDATE_REQUEST);
export const tracksUpdateSuccess = actionCreator<Album>(actionTypes.TRACK_UPDATE_SUCCESS);
export const tracksUpdateFailure = actionCreator<HttpStateError>(actionTypes.TRACK_UPDATE_FAILURE);

export const requestTracksDestroy = actionCreator<number>(actionTypes.TRACK_DESTROY_REQUEST);
export const tracksDestroySuccess = actionCreator<number>(actionTypes.TRACK_DESTROY_SUCCESS);
export const tracksDestroyFailure = actionCreator<HttpStateError>(actionTypes.TRACK_DESTROY_FAILURE);

export const requestTracksSearch = actionCreator<string>(actionTypes.TRACK_SEARCH_REQUEST);
export const tracksSearchSuccess = actionCreator<NormalisedResult<number[], MusicNormalisedEntities>>(
    actionTypes.TRACK_SEARCH_SUCCESS,
);
export const tracksSearchFailure = actionCreator<HttpStateError>(actionTypes.TRACK_SEARCH_FAILURE);

export type MusicAction = Action<HttpStateError> | Action<{}> | Action<Album> |
    Action<Track> | Action<NormalisedResult<number[], MusicNormalisedEntities>> |
    Action<NormalisedResult<number, MusicNormalisedEntities>> | Action<number>;

// Artists
export const requestArtistsShow = actionCreator<number>(actionTypes.ARTIST_SHOW_REQUEST);
export const artistsShowSuccess = actionCreator<NormalisedResult<number, MusicNormalisedEntities>>(
    actionTypes.ARTIST_SHOW_SUCCESS,
);
export const artistsShowFailure = actionCreator<HttpStateError>(actionTypes.ARTIST_SHOW_FAILURE);
